import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import AssetRequestManagementWidgets from '../../../widgets/assetRequestManagementWidgets/AssetRequestManagementWidgets'
import { getAssetRequestManagement } from '../../../redux/actions/assetRequestManagement'

export default function AssetRequestManagement() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const userCode = localStorage.getItem('thp_user_code')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getAssetRequestManagement(1, 5)
      console.log('schema ggg => ', _schema)

      setSchema(_schema.model)
      // setSchema(mockSchema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssetCirculating>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssetCirculating>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isAssetCirculating>
        <ContentHeader
          header={schema.header}
          subHeader={schema?.subHeader || ''}
          isNotCallApi
          isShowGoButton
        />

        <AssetRequestManagementWidgets schema={schema.form} />

        <br />
      </SidebarProposal>
    </div>
  )
}

const mockSchema = {
  header: 'จัดการรายการขอใช้ครุภัณฑ์',
  subHeader: '',
  disabled: false,
  form: {
    header: 'รายการคำขอใช้ครุภัณฑ์โครงการ',
    searchForm: {
      header: 'ค้นหารายการขอใช้',
      projectCode: {
        label: 'รหัสโครงการ',
        name: 'projectCode',
        value: '',
      },
      projectName: {
        label: 'ชื่อโครงการ',
        name: 'projectName',
        value: '',
      },
      requestForUseDocNo: {
        name: 'requestForUseDocNo',
        label: 'เลขที่คำขอใช้',
        value: '',
      },
      requestForUseStatus: {
        label: 'สถานะขอใช้',
        name: 'requestForUseStatus',
        value: '',
        options: [],
      },
      startDate: {
        label: 'วันที่ขอใช้เริ่มต้น',
        name: 'startDate',
        value: '',
      },
      endDate: {
        label: 'วันที่ขอใช้สิ้นสุด',
        name: 'endDate',
        value: '',
      },
    },
    result: {
      totalSize: 0,
      values: [
        {
          id: '',
          requestForUseDocNo: '',
          requestForUseDate: '',
          projectCode: '',
          projectName: '',
          assetCount: '',
          requestForUseStatus: '',
          requester: '',
        },
      ],
    },
  },
}
